/* eslint-disable jsx-a11y/no-noninteractive-element-interactions */
import React, { useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { ButtonPrimary } from '../../../../utils/Button';
import { GetDate } from '../../../../utils/Show';
import { TextCapitalize } from '../../../../utils/TextFormatter';
import { mkRelativeUrl } from '../../../../utils/URL';
import cn from '../../../../utils/cn';
import { useAdminListInfo } from '../AdminsListProvider';

function PermissionsRow({ item }) {
    return (
        <div className="flex flex-wrap gap-1 font-medium">
            {item?.permissions?.slice(0, 1)?.map((d) => {
                return (
                    <span
                        key={d}
                        className="bg-secondary-200 p-0.5 px-2 rounded-5 text-xs text-secondary"
                    >
                        {TextCapitalize(d)}
                    </span>
                );
            })}
            {item?.permissions?.length > 2 ? (
                <Link
                    to={mkRelativeUrl(`/settings/admins/${item?.id}/info`)}
                    className="mt-1 block text-secondary text-xs underline"
                >
                    More..
                </Link>
            ) : null}
        </div>
    );
}

function TableInfoCard({ name, value, isCapitalize, className }) {
    return (
        <div
            className={cn(
                'text-sm text-primary-700 font-medium flex flex-row gap-3 justify-start items-center h-5',
                className
            )}
        >
            <p className="inline-flex justify-between items-center min-w-[112px] w-28">
                <span>{name}</span>
                <span>:</span>
            </p>
            <span
                className={cn(`line-clamp-1 text-primary font-normal text-sm`, {
                    capitalize: isCapitalize
                })}
            >
                {value}
            </span>
        </div>
    );
}

function TableRow({ item }) {
    const navigate = useNavigate();
    const [isTrActive, setIsTrActive] = useState(false);

    const {
        handleCustomerTypeModal,
        handleCustomerStatusModal,
        handleShowEditModal,
        handleDisable2FA
    } = useAdminListInfo();

    const isActive = item?.status === 'active';
    return (
        <div
            tabIndex={-1}
            role="button"
            onClick={() => setIsTrActive((cu) => !cu)}
            className={cn(
                `table-visible-data overflow-hidden w-full flex flex-col justify-between text-primary p-2.5 rounded-md transition-all duration-[800ms] ease-in-out remove-highlight`,
                {
                    'max-h-72': isTrActive,
                    'max-h-10': !isTrActive,
                    'placeholder-mode': item.demo
                }
            )}
        >
            <div className="w-full flex flex-row gap-1 justify-between text-primary text-sm font-medium leading-normal">
                <div className="min-w-[112px] w-28">
                    <span>{item?.id}</span>
                </div>
                <div className="w-full">
                    <span className="line-clamp-1">
                        {item?.fullName}{' '}
                        {item?.permissions?.includes('admin.manager') && (
                            <span className="text-secondary text-xs">(Super Admin)</span>
                        )}
                    </span>
                </div>
                <div className="w-full hidden sm:block">
                    <span
                        className={`line-clamp-1 capitalize ${
                            isActive ? 'text-success' : 'text-warning'
                        }`}
                    >
                        {item?.status}
                    </span>
                </div>
            </div>

            <div className="table-data-more mt-3.5 flex flex-col justify-start items-item gap-2">
                <TableInfoCard name="Email" value={item?.primaryEmail} />

                <TableInfoCard
                    name="Date Created"
                    value={GetDate(item?.timeCreated)}
                    isCapitalize
                />

                <TableInfoCard
                    name="Permissions"
                    value={<PermissionsRow item={item} />}
                    className="h-auto"
                />

                <TableInfoCard
                    name="2FA"
                    value={
                        item?.tfaEnabled ? (
                            <span className="text-success">Enabled</span>
                        ) : (
                            <span className="text-error">Disabled</span>
                        )
                    }
                />
                <TableInfoCard
                    name="Status"
                    value={
                        isActive ? (
                            <span className="text-success">{item?.status}</span>
                        ) : (
                            <span className="text-warning">{item?.status}</span>
                        )
                    }
                    className={`sm:hidden ${isActive ? '[&>.value-text]:text-success' : '[&>.value-text]:text-error'}`}
                    isCapitalize
                />

                <div className="flex flex-row flex-wrap gap-px justify-end items-center">
                    <ButtonPrimary
                        btnType="button"
                        title="Manage"
                        onClick={() => navigate(mkRelativeUrl(`/settings/admins/${item?.id}/info`))}
                    />
                    {isActive && (
                        <ButtonPrimary
                            btnType="button"
                            title="Edit Info"
                            onClick={(ev) => handleShowEditModal(ev, item)}
                        />
                    )}
                    {isActive && (
                        <ButtonPrimary
                            btnType="button"
                            title="Change Role"
                            onClick={(ev) => handleCustomerTypeModal(ev, item)}
                        />
                    )}

                    <ButtonPrimary
                        btnType="button"
                        title={item?.status === 'active' ? 'Make Inactive' : 'Make Active'}
                        onClick={(ev) => handleCustomerStatusModal(ev, item)}
                    />

                    {item?.tfaEnabled && isActive && (
                        <ButtonPrimary
                            btnType="button"
                            title="Disable 2FA"
                            onClick={handleDisable2FA}
                        />
                    )}
                </div>
            </div>
        </div>
    );
}

function PageTableMobile({ data }) {
    return (
        <div className="customer_page_table">
            <div className="table-data [&>*:nth-child(odd)]:bg-primary-50">
                {data && data?.length === 0 ? (
                    <div className="w-full text-sm font-medium p-2 rounded-5">No Data Found</div>
                ) : (
                    data?.map((item) => <TableRow key={item.id} item={item} />)
                )}
            </div>
        </div>
    );
}

export default PageTableMobile;
